"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var RoundCross2_exports = {};
__export(RoundCross2_exports, {
  default: () => RoundCross2_default
});
module.exports = __toCommonJS(RoundCross2_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.5 1.79297C11.6719 1.79297 12.7721 2.01432 13.8008 2.45703C14.8164 2.89974 15.7083 3.50521 16.4766 4.27344C17.2448 5.04167 17.8503 5.93359 18.293 6.94922C18.7357 7.97786 18.957 9.07812 18.957 10.25C18.957 11.4219 18.7357 12.5221 18.293 13.5508C17.8503 14.5664 17.2448 15.4583 16.4766 16.2266C15.7083 16.9948 14.8164 17.6003 13.8008 18.043C12.7721 18.4857 11.6719 18.707 10.5 18.707C9.32812 18.707 8.22786 18.4857 7.19922 18.043C6.18359 17.6003 5.29167 16.9948 4.52344 16.2266C3.75521 15.4583 3.14974 14.5664 2.70703 13.5508C2.26432 12.5221 2.04297 11.4219 2.04297 10.25C2.04297 9.07812 2.26432 7.97786 2.70703 6.94922C3.14974 5.93359 3.75521 5.04167 4.52344 4.27344C5.29167 3.50521 6.18359 2.89974 7.19922 2.45703C8.22786 2.01432 9.32812 1.79297 10.5 1.79297ZM10.5 3.27734C9.53646 3.27734 8.63151 3.45964 7.78516 3.82422C6.9388 4.1888 6.19661 4.6901 5.55859 5.32812C4.93359 5.95312 4.4388 6.6888 4.07422 7.53516C3.70964 8.38151 3.52734 9.28646 3.52734 10.25C3.52734 11.2135 3.70964 12.1185 4.07422 12.9648C4.4388 13.8112 4.93359 14.5534 5.55859 15.1914C6.19661 15.8164 6.9388 16.3112 7.78516 16.6758C8.63151 17.0404 9.53646 17.2227 10.5 17.2227C11.4635 17.2227 12.3685 17.0404 13.2148 16.6758C14.0612 16.3112 14.7969 15.8164 15.4219 15.1914C16.0599 14.5534 16.5612 13.8112 16.9258 12.9648C17.2904 12.1185 17.4727 11.2135 17.4727 10.25C17.4727 9.28646 17.2904 8.38151 16.9258 7.53516C16.5612 6.6888 16.0599 5.95312 15.4219 5.32812C14.7969 4.6901 14.0612 4.1888 13.2148 3.82422C12.3685 3.45964 11.4635 3.27734 10.5 3.27734ZM13.1367 7.06641C13.2279 6.96224 13.3385 6.90365 13.4688 6.89062C13.599 6.8776 13.7227 6.89714 13.8398 6.94922L13.918 7.00781L13.9961 7.06641C14.1003 7.17057 14.1589 7.30078 14.1719 7.45703C14.1849 7.60026 14.1458 7.73047 14.0547 7.84766L13.9961 7.92578L11.5156 10.4062L13.9961 12.8867C14.0872 12.9779 14.1393 13.0885 14.1523 13.2188C14.1784 13.349 14.1654 13.4727 14.1133 13.5898L14.0547 13.668L13.9961 13.7461C13.8919 13.8503 13.7617 13.9089 13.6055 13.9219C13.4492 13.9349 13.3125 13.8958 13.1953 13.8047L13.1367 13.7461L10.6562 11.2656L8.17578 13.7461C8.08464 13.8372 7.96745 13.8958 7.82422 13.9219C7.69401 13.9349 7.57682 13.9154 7.47266 13.8633L7.375 13.8047L7.31641 13.7461C7.21224 13.6419 7.15365 13.5117 7.14062 13.3555C7.1276 13.1992 7.16667 13.0625 7.25781 12.9453L7.31641 12.8867L9.79688 10.4062L7.31641 7.92578C7.21224 7.83464 7.15365 7.72396 7.14062 7.59375C7.1276 7.45052 7.14714 7.32682 7.19922 7.22266L7.25781 7.125L7.31641 7.06641C7.42057 6.96224 7.54427 6.90365 7.6875 6.89062C7.84375 6.8776 7.98047 6.91667 8.09766 7.00781L8.17578 7.06641L10.6562 9.54688L13.1367 7.06641Z",
      fill: "currentColor"
    }
  )
);
const SvgRoundCross2 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var RoundCross2_default = SvgRoundCross2;
